import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommerceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Commerce",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.34 30h-8.61c-2.91 0-5.46-1.54-6.82-4.11s-1.2-5.54.44-7.95l5.53-9.92-2.7-4.5a.99.99 0 0 1-.01-1.01c.18-.31.51-.51.87-.51h14c.36 0 .69.19.87.51.18.31.17.7-.01 1.01l-2.7 4.5 5.56 9.96c1.61 2.4 1.77 5.35.41 7.91-1.36 2.57-3.91 4.11-6.82 4.11ZM10.8 4l2.09 3.49c.18.31.19.69.02 1l-5.86 10.5c-1.26 1.86-1.38 4.06-.37 5.97S9.58 28 11.73 28h8.61c2.16 0 4.05-1.14 5.05-3.04s.89-4.11-.33-5.89c-.02-.02-.03-.05-.05-.08l-5.86-10.5a1 1 0 0 1 .02-1L21.26 4H10.79Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.87 23.33h-3.33c-.55 0-1-.45-1-1s.45-1 1-1h3.33a.67.67 0 0 0 0-1.34H15.2c-1.47 0-2.67-1.2-2.67-2.67s1.2-2.67 2.67-2.67h3.33c.55 0 1 .45 1 1s-.45 1-1 1H15.2a.67.67 0 0 0 0 1.34h1.67c1.47 0 2.67 1.2 2.67 2.67s-1.2 2.67-2.67 2.67"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.04 25c-.55 0-1-.45-1-1v-1.67c0-.55.45-1 1-1s1 .45 1 1V24c0 .55-.45 1-1 1M16.04 16.67c-.55 0-1-.45-1-1V14c0-.55.45-1 1-1s1 .45 1 1v1.67c0 .55-.45 1-1 1M16.04 9h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
    })]
  }));
};